export enum NotificationDuration {
  DEFAULT = 5000,
}
